interface EmailData {
  to: string;
  subject: string;
  html: string;
  from?: string;
}

export const emailService = {
  async sendQuoteConfirmation(quoteData: {
    name: string;
    email: string;
    company: string;
    model_name: string;
    phone: string;
  }) {
    try {
      const response = await fetch('/api/send-email', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          to: quoteData.email,
          subject: `Quote Request Received - ${quoteData.model_name}`,
          html: `
            <!DOCTYPE html>
            <html>
              <head>
                <meta charset="utf-8">
                <title>Quote Request Confirmation</title>
              </head>
              <body style="font-family: Arial, sans-serif; line-height: 1.6; color: #333;">
                <div style="max-width: 600px; margin: 0 auto; padding: 20px;">
                  <h1 style="color: #2563eb;">Thank You for Your Quote Request!</h1>
                  
                  <p>Dear ${quoteData.name},</p>
                  
                  <p>We have received your quote request for the <strong>${quoteData.model_name}</strong>.</p>
                  
                  <div style="background-color: #f3f4f6; padding: 20px; border-radius: 8px; margin: 20px 0;">
                    <h2 style="margin-top: 0; color: #1f2937;">Request Details:</h2>
                    <ul style="list-style: none; padding: 0;">
                      <li><strong>Company:</strong> ${quoteData.company}</li>
                      <li><strong>Model:</strong> ${quoteData.model_name}</li>
                      <li><strong>Contact:</strong> ${quoteData.phone}</li>
                    </ul>
                  </div>
                  
                  <p>Our sales team will contact you within <strong>24 hours</strong> with detailed pricing, specifications, and availability information.</p>
                  
                  <p>If you have any urgent questions, please contact us:</p>
                  <ul>
                    <li>WhatsApp: <a href="https://wa.me/8618257879431">+86 182 5787 9431</a></li>
                    <li>Email: <a href="mailto:xiaoyunc955@gmail.com">xiaoyunc955@gmail.com</a></li>
                    <li>WeChat: 18258995859</li>
                  </ul>
                  
                  <p style="margin-top: 30px;">Best regards,<br><strong>Wuxi Qijue Sales Team</strong></p>
                  
                  <hr style="border: none; border-top: 1px solid #e5e7eb; margin: 30px 0;">
                  
                  <p style="font-size: 12px; color: #6b7280;">
                    This is an automated message. Please do not reply directly to this email.
                  </p>
                </div>
              </body>
            </html>
          `
        })
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Failed to send confirmation email');
      }

      return await response.json();
    } catch (error: any) {
      console.error('Error sending quote confirmation:', error);
      throw new Error(error?.message || 'Failed to send confirmation email');
    }
  },

  async notifyTeam(quoteData: {
    name: string;
    company: string;
    country: string;
    phone: string;
    email: string;
    model_name: string;
    message?: string;
  }) {
    try {
      const response = await fetch('/api/send-email', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          to: 'xiaoyunc955@gmail.com',
          subject: `New Quote Request - ${quoteData.model_name}`,
          html: `
            <!DOCTYPE html>
            <html>
              <head>
                <meta charset="utf-8">
                <title>New Quote Request</title>
              </head>
              <body style="font-family: Arial, sans-serif; line-height: 1.6; color: #333;">
                <div style="max-width: 600px; margin: 0 auto; padding: 20px;">
                  <h1 style="color: #dc2626;">New Quote Request Received</h1>
                  
                  <div style="background-color: #fef2f2; padding: 20px; border-radius: 8px; border-left: 4px solid #dc2626; margin: 20px 0;">
                    <h2 style="margin-top: 0; color: #7f1d1d;">Customer Information:</h2>
                    <ul style="list-style: none; padding: 0;">
                      <li><strong>Name:</strong> ${quoteData.name}</li>
                      <li><strong>Company:</strong> ${quoteData.company}</li>
                      <li><strong>Country:</strong> ${quoteData.country}</li>
                      <li><strong>Phone:</strong> ${quoteData.phone}</li>
                      <li><strong>Email:</strong> ${quoteData.email}</li>
                    </ul>
                  </div>
                  
                  <div style="background-color: #eff6ff; padding: 20px; border-radius: 8px; border-left: 4px solid #2563eb; margin: 20px 0;">
                    <h2 style="margin-top: 0; color: #1e3a8a;">Product Interest:</h2>
                    <p><strong>${quoteData.model_name}</strong></p>
                  </div>
                  
                  ${quoteData.message ? `
                    <div style="background-color: #f3f4f6; padding: 20px; border-radius: 8px; margin: 20px 0;">
                      <h2 style="margin-top: 0; color: #1f2937;">Message:</h2>
                      <p>${quoteData.message}</p>
                    </div>
                  ` : ''}
                  
                  <p style="margin-top: 30px; font-weight: bold; color: #dc2626;">
                    ⏰ Action Required: Contact within 24 hours
                  </p>
                  
                  <hr style="border: none; border-top: 1px solid #e5e7eb; margin: 30px 0;">
                  
                  <p style="font-size: 12px; color: #6b7280;">
                    This notification was sent from the Wuxi Qijue catalog system.
                  </p>
                </div>
              </body>
            </html>
          `
        })
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Failed to notify team');
      }

      return await response.json();
    } catch (error: any) {
      console.error('Error notifying team:', error);
      throw new Error(error?.message || 'Failed to send team notification');
    }
  },

  async sendContactConfirmation(contactData: {
    name: string;
    email: string;
    company: string;
    interest: string;
  }) {
    try {
      const response = await fetch('/api/send-email', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          to: contactData.email,
          subject: 'Contact Request Received - Wuxi Qijue',
          html: `
            <!DOCTYPE html>
            <html>
              <head>
                <meta charset="utf-8">
                <title>Contact Request Confirmation</title>
              </head>
              <body style="font-family: Arial, sans-serif; line-height: 1.6; color: #333;">
                <div style="max-width: 600px; margin: 0 auto; padding: 20px;">
                  <h1 style="color: #2563eb;">Thank You for Contacting Us!</h1>
                  
                  <p>Dear ${contactData.name},</p>
                  
                  <p>We have received your contact request regarding <strong>${contactData.interest}</strong>.</p>
                  
                  <div style="background-color: #f3f4f6; padding: 20px; border-radius: 8px; margin: 20px 0;">
                    <h2 style="margin-top: 0; color: #1f2937;">Request Details:</h2>
                    <ul style="list-style: none; padding: 0;">
                      <li><strong>Company:</strong> ${contactData.company}</li>
                      <li><strong>Interest:</strong> ${contactData.interest}</li>
                    </ul>
                  </div>
                  
                  <p>Our team will review your inquiry and contact you within <strong>24 hours</strong>.</p>
                  
                  <p>If you have any urgent questions, please contact us:</p>
                  <ul>
                    <li>WhatsApp: <a href="https://wa.me/8618257879431">+86 182 5787 9431</a></li>
                    <li>Email: <a href="mailto:xiaoyunc955@gmail.com">xiaoyunc955@gmail.com</a></li>
                    <li>WeChat: 18258995859</li>
                  </ul>
                  
                  <p style="margin-top: 30px;">Best regards,<br><strong>Wuxi Qijue Business Development Team</strong></p>
                  
                  <hr style="border: none; border-top: 1px solid #e5e7eb; margin: 30px 0;">
                  
                  <p style="font-size: 12px; color: #6b7280;">
                    This is an automated message. Please do not reply directly to this email.
                  </p>
                </div>
              </body>
            </html>
          `
        })
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Failed to send confirmation email');
      }

      return await response.json();
    } catch (error: any) {
      throw new Error(error?.message || 'Failed to send confirmation email');
    }
  },

  async notifyTeamContact(contactData: {
    name: string;
    company: string;
    country: string;
    phone: string;
    email: string;
    message: string;
    interest: string;
  }) {
    try {
      const interestLabels: Record<string, string> = {
        distributor: 'Become a Distributor',
        oem: 'OEM Partnership',
        bulk: 'Bulk Purchase',
        technical: 'Technical Information',
        other: 'Other Inquiry'
      };

      const response = await fetch('/api/send-email', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          to: 'xiaoyunc955@gmail.com',
          subject: `New Contact Inquiry - ${interestLabels[contactData.interest] || contactData.interest}`,
          html: `
            <!DOCTYPE html>
            <html>
              <head>
                <meta charset="utf-8">
                <title>New Contact Inquiry</title>
              </head>
              <body style="font-family: Arial, sans-serif; line-height: 1.6; color: #333;">
                <div style="max-width: 600px; margin: 0 auto; padding: 20px;">
                  <h1 style="color: #dc2626;">New Contact Inquiry Received</h1>
                  
                  <div style="background-color: #fef2f2; padding: 20px; border-radius: 8px; border-left: 4px solid #dc2626; margin: 20px 0;">
                    <h2 style="margin-top: 0; color: #7f1d1d;">Contact Information:</h2>
                    <ul style="list-style: none; padding: 0;">
                      <li><strong>Name:</strong> ${contactData.name}</li>
                      <li><strong>Company:</strong> ${contactData.company}</li>
                      <li><strong>Country:</strong> ${contactData.country}</li>
                      <li><strong>Phone:</strong> ${contactData.phone}</li>
                      <li><strong>Email:</strong> ${contactData.email}</li>
                    </ul>
                  </div>
                  
                  <div style="background-color: #eff6ff; padding: 20px; border-radius: 8px; border-left: 4px solid #2563eb; margin: 20px 0;">
                    <h2 style="margin-top: 0; color: #1e3a8a;">Inquiry Type:</h2>
                    <p><strong>${interestLabels[contactData.interest] || contactData.interest}</strong></p>
                  </div>
                  
                  <div style="background-color: #f3f4f6; padding: 20px; border-radius: 8px; margin: 20px 0;">
                    <h2 style="margin-top: 0; color: #1f2937;">Message:</h2>
                    <p>${contactData.message}</p>
                  </div>
                  
                  <p style="margin-top: 30px; font-weight: bold; color: #dc2626;">
                    ⏰ Action Required: Contact within 24 hours
                  </p>
                  
                  <hr style="border: none; border-top: 1px solid #e5e7eb; margin: 30px 0;">
                  
                  <p style="font-size: 12px; color: #6b7280;">
                    This notification was sent from the Wuxi Qijue contact system.
                  </p>
                </div>
              </body>
            </html>
          `
        })
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Failed to notify team');
      }

      return await response.json();
    } catch (error: any) {
      throw new Error(error?.message || 'Failed to send team notification');
    }
  },

  // New method for triggering email sequence
  async triggerEmailSequence(leadId: string, leadType: 'contact' | 'quote') {
    try {
      const response = await fetch(`${process.env.NEXT_PUBLIC_SUPABASE_URL}/functions/v1/send-sequence-email`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY}`
        },
        body: JSON.stringify({ leadId, leadType })
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Failed to trigger email sequence');
      }

      return await response.json();
    } catch (error: any) {
      throw new Error(error?.message || 'Failed to trigger email sequence');
    }
  },

  // Manual sequence management methods
  async pauseEmailSequence(sequenceId: string) {
    try {
      const { createClient } = await import('../lib/supabase');
      const supabase = createClient();
      
      const { error } = await supabase
        .from('email_sequences')
        .update({ status: 'paused', updated_at: new Date().toISOString() })
        .eq('id', sequenceId);

      if (error) throw error;
      return { success: true };
    } catch (error: any) {
      throw new Error(error?.message || 'Failed to pause email sequence');
    }
  },

  async resumeEmailSequence(sequenceId: string) {
    try {
      const { createClient } = await import('../lib/supabase');
      const supabase = createClient();
      
      const { error } = await supabase
        .from('email_sequences')
        .update({ status: 'active', updated_at: new Date().toISOString() })
        .eq('id', sequenceId);

      if (error) throw error;
      return { success: true };
    } catch (error: any) {
      throw new Error(error?.message || 'Failed to resume email sequence');
    }
  },

  async getSequenceStatus(leadId: string) {
    try {
      const { createClient } = await import('../lib/supabase');
      const supabase = createClient();
      
      const { data, error } = await supabase
        .from('email_sequences')
        .select('*, email_sequence_logs(*)')
        .eq('lead_id', leadId)
        .single();

      if (error) throw error;
      return data;
    } catch (error: any) {
      throw new Error(error?.message || 'Failed to get sequence status');
    }
  }
};